module.exports = __webpack_public_path__ + "img/775-5ce83f.png";